import api from './base-api';

const lobbiesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		// PUBLIC
		getEliminatedUsersCount: builder.query({
			query: (lobbyId: any) => ({
				url: `/lobbies/${lobbyId}/eliminated-users/count`,
				method: 'GET',
			}),
			providesTags: (result: any, error: any, lobbyId: any) => [
				{ type: 'Lobby', id: `ELIMINATED_COUNT_${lobbyId}` },
			],
			extraOptions: { skipAuth: true },
		}),
		initiateRevival: builder.mutation({
			query: ({ lobbyId, reviveCount }: any) => ({
				url: `/lobbies/${lobbyId}/initiate-revival`,
				method: 'POST',
				body: { reviveCount },
			}),
			invalidatesTags: (result: any, error: any, { lobbyId }: any) => [
				{ type: 'Lobby', id: `ELIMINATED_COUNT_${lobbyId}` },
				{ type: 'Lobby', id: `REVIVAL_SUGGESTION_${lobbyId}` },
			],
			extraOptions: { skipAuth: true },
		}),
		getStationLobbies: builder.query({
			query: (slug: any) => ({
				url: `lobbies/sponsor/${slug}`,
			}),
			extraOptions: { skipAuth: true },
		}),
		getLeaderboard: builder.query({
			query: (data: any) => ({
				url: '/lobbies/leaderboard',
				method: 'POST',
				body: data,
			}),
			providesTags: (result: any, error: any, { lobbyId }: any) => [
				{ type: 'Lobby', id: `LEADERBOARD_${lobbyId}` },
			],
			extraOptions: { skipAuth: true },
		}),

		// PRIVATE
		getSurvivorIntro: builder.query({
			query: () => `/lobbies/survivor-intro`,
		}),
		getUserLeaderboardRank: builder.query({
			query: (data: any) => ({
				url: '/lobbies/leaderboard/rank',
				method: 'POST',
				body: data,
			}),
			providesTags: (result: any, error: any, { lobbyId }: any) => [
				{ type: 'Lobby', id: `USER_RANK_${lobbyId}` },
			],
		}),

		// ADMIN
		updateRevivalCount: builder.mutation({
			query: ({ lobbyId, revivalCount }: any) => ({
				url: `/lobbies/${lobbyId}/revival-count`,
				method: 'PATCH',
				body: { revivalCount },
			}),
		}),
		getRevivalSuggestion: builder.query({
			query: (lobbyId: any) => ({
				url: `/lobbies/${lobbyId}/revival-suggestion`,
				method: 'GET',
			}),
			providesTags: (result: any, error: any, lobbyId: any) => [
				{ type: 'Lobby', id: `REVIVAL_SUGGESTION_${lobbyId}` },
			],
		}),
		updateLobbyPriority: builder.mutation({
			query: ({ lobbyId, priority }: any) => ({
				url: `lobbies/${lobbyId}/priority`,
				method: 'PATCH',
				body: { priority },
			}),
			invalidatesTags: (result: any, error: any, { lobbyId }: any) => [
				{ type: 'Lobby', id: lobbyId },
				{ type: 'Lobby', id: 'LIST' },
			],
		}),
		getLobbiesBySlateId: builder.query({
			query: (body: { eventId: string; slateId?: string }) => ({
				url: `lobbies/by-slate`,
				method: 'POST',
				body,
			}),
			providesTags: [{ type: 'Lobby', id: 'LIST' }],
		}),
		getLobbiesByEventIdForAdmin: builder.query({
			query: (eventId: string) => ({
				url: `lobbies/event/${eventId}/admin`,
				method: 'GET',
			}),
			providesTags: (result: any, error: any, eventId: string) => [
				{ type: 'Lobby', id: `EVENT_ADMIN_${eventId}` },
			],
		}),
	}),
	overrideExisting: false,
});

export default lobbiesApi;

export const {
	useGetEliminatedUsersCountQuery,
	useInitiateRevivalMutation,
	useUpdateRevivalCountMutation,
	useGetRevivalSuggestionQuery,
	useGetStationLobbiesQuery,
	useGetSurvivorIntroQuery,
	useUpdateLobbyPriorityMutation,
	useGetLeaderboardQuery,
	useGetUserLeaderboardRankQuery,
	useGetLobbiesBySlateIdQuery,
	useGetLobbiesByEventIdForAdminQuery,
	useLazyGetLobbiesByEventIdForAdminQuery,
} = lobbiesApi;
